import { TooltipPlaceE } from "../../../models/enums";

/**
 * Define tooltip position based on current direction
 * */

export const getPlaceDirection = (
  place: TooltipPlaceE,
  isRtlDirection: boolean
) => {
  if (place === TooltipPlaceE.RIGHT && isRtlDirection)
    return TooltipPlaceE.LEFT;
  if (place === TooltipPlaceE.LEFT && isRtlDirection)
    return TooltipPlaceE.RIGHT;
  return place;
};
